<script>
    import { onMount, tick } from "svelte";
    import { keyphrases, competitorUrls } from "../../../app-store";
    import { debounce, normalizeUrl, isValidUrl, checkUrl } from "../../../services/utils";

    export let params;
    export let draftSubtmit = () => {};

    let keyphrasesCarousel = null;
    let keyphrasesSliderEl = null;
    let competitorCarousel = null;
    let competitorUrlsSliderEl = null;
    let isLoading = false;

    const keywordMaxLength = 1000;
    const urlMaxLength = 1000;

    const addKeypharases = () => {
        if (isLoading) {
            return;
        }
        const newCardId = `keyphrases-${$keyphrases.length + 1}`;
        $keyphrases = [
            ...$keyphrases,
            {
                id: newCardId,
                url: "",
                keyword: "",
                urlref: "",
                status: "",
                isDisabled: false,
            },
        ];
    };

    const removeKeyphrases = (id) => {
        $keyphrases = $keyphrases.filter((card) => card.id !== id);
    };

    const addCompetitorUrlCard = () => {
        const newCardId = `competitor-${$competitorUrls.length + 1}`;
        $competitorUrls = [...$competitorUrls, { id: newCardId, url: "" }];
    };

    const removeCompetitorUrlCard = (id) => {
        $competitorUrls = $competitorUrls.filter((card) => card.id !== id);
    };

    const showCardStatusClass = (status = "") => {
        switch (status) {
            case "valid":
                return "form-card-ok";
            case "invalid":
                return "form-card-error";
            case "crawl-error":
                return "form-card-crawl-error";
            default:
                return "";
        }
    };

    const validateKeyphrasesCard = (e, id, keyword, url) => {
        const normalizedUrl = normalizeUrl(url);

        if (keyword === "" || normalizedUrl === "") {
            return;
        }

        if (url !== normalizedUrl) {
            $keyphrases = $keyphrases.map((item) => {
                if (item.id === id) {
                    return { ...item, url: normalizedUrl };
                }
                return item;
            });
        }

        if (keyword.length > keywordMaxLength) {
            app.toast_msg.show("Keyword exceeds maximum length of " + keywordMaxLength + " characters");
            $keyphrases = $keyphrases.map((item) => {
                if (item.id === id) {
                    return { ...item, status: "invalid" };
                }
                return item;
            });
            return;
        }

        if (normalizedUrl.length > urlMaxLength) {
            app.toast_msg.show("URL exceeds maximum length of " + urlMaxLength + " characters");
            $keyphrases = $keyphrases.map((item) => {
                if (item.id === id) {
                    return { ...item, status: "invalid" };
                }
                return item;
            });
            return;
        }

        if (!isValidUrl(normalizedUrl)) {
            app.toast_msg.show("Invalid URL format");
            $keyphrases = $keyphrases.map((item) => {
                if (item.id === id) {
                    return { ...item, status: "invalid" };
                }
                return item;
            });
            return;
        }

        const spinner = window.create_spinner({ classname: "spinner-check-urlref animate-in" });
        const formCardContainerEl = e.target.closest(".form-card-fieldset");
        spinner.set_message("Checking URL...");
        spinner.add_to(formCardContainerEl);
        isLoading = true;
        checkUrl(params.draft_refcode, normalizedUrl, null, {
            ok: (content, urlref) => {
                $keyphrases = $keyphrases.map((item) => {
                    if (item.id === id) {
                        return { ...item, status: "valid", urlref: urlref, isDisabled: true };
                    }
                    return item;
                });
            },
            invalid: () => {
                app.toast_msg.show("Invalid URL");
                $keyphrases = $keyphrases.map((item) => {
                    if (item.id === id) {
                        return { ...item, status: "invalid", isDisabled: false };
                    }
                    return item;
                });
            },
            fail: (err) => {
                app.toast_msg.show("Error checking URL");
                $keyphrases = $keyphrases.map((item) => {
                    if (item.id === id) {
                        return { ...item, status: "crawl-error", isDisabled: false };
                    }
                    return item;
                });
                console.error("Error checking URL:", err);
            },
            done: () => {
                spinner.remove();
                isLoading = false;
            },
        });
    };

    const validateCompetitorUrlCard = (e, id, url) => {
        const normalizedUrl = normalizeUrl(url);
        if (normalizedUrl === "") {
            return;
        }

        if (url !== normalizedUrl) {
            $competitorUrls = $competitorUrls.map((item) => {
                if (item.id === id) {
                    return { ...item, url: normalizedUrl };
                }
                return item;
            });
        }

        if (normalizedUrl.length > urlMaxLength) {
            app.toast_msg.show("URL exceeds maximum length of " + urlMaxLength + " characters");
            $competitorUrls = $competitorUrls.map((item) => {
                if (item.id === id) {
                    return { ...item, status: "invalid" };
                }
                return item;
            });
            return;
        }

        if (!isValidUrl(normalizedUrl)) {
            app.toast_msg.show("Invalid URL format");
            $competitorUrls = $competitorUrls.map((item) => {
                if (item.id === id) {
                    return { ...item, status: "invalid" };
                }
                return item;
            });
            return;
        }

        const spinner = window.create_spinner({ classname: "spinner-check-urlref animate-in" });
        const formCardContainerEl = e.target.closest(".form-card-fieldset");
        spinner.set_message("Checking URL...");
        spinner.add_to(formCardContainerEl);
        isLoading = true;
        checkUrl(params.draft_refcode, normalizedUrl, null, {
            ok: (urlref) => {
                $competitorUrls = $competitorUrls.map((item) => {
                    if (item.id === id) {
                        return { ...item, status: "valid", urlref: urlref, isDisabled: true };
                    }
                    return item;
                });
            },
            invalid: () => {
                app.toast_msg.show("Invalid URL");
                $competitorUrls = $competitorUrls.map((item) => {
                    if (item.id === id) {
                        return { ...item, status: "invalid", isDisabled: false };
                    }
                    return item;
                });
            },
            fail: (err) => {
                app.toast_msg.show("Error checking URL");
                $competitorUrls = $competitorUrls.map((item) => {
                    if (item.id === id) {
                        return { ...item, status: "crawl-error", isDisabled: false };
                    }
                    return item;
                });
                console.error("Error checking URL:", err);
            },
            done: async () => {
                spinner.remove();
                isLoading = false;
            },
        });
    };

    onMount(() => {
        keyphrasesCarousel = window.EmblaCarousel(keyphrasesSliderEl, {
            loop: false,
            align: "start",
        });

        keyphrasesCarousel.on("slidesChanged", (e) => {
            keyphrasesCarousel.scrollTo(keyphrasesCarousel.selectedScrollSnap() + 1);
        });

        competitorCarousel = window.EmblaCarousel(competitorUrlsSliderEl, {
            loop: false,
            align: "start",
        });

        competitorCarousel.on("slidesChanged", (e) => {
            competitorCarousel.scrollTo(competitorCarousel.selectedScrollSnap() + 1);
        });
    });
</script>

<div class="manual-draft">

<div class="row mb-5 mt-5">
    <div class="col-lg-3">
        <h4 class="form-card-title">Keyphrases & References</h4>
        <p class="form-card-title text-muted">Guide the Agent with Keywords &amp; References</p>
    </div>
    <div class="slider-container col-lg-9">
        <button
            on:click={() => keyphrasesCarousel.scrollPrev()}
            class="btn embla__button embla__button--prev"
            aria-label="Previous"
        >
            <img src="/img/arrow-left-wide-fill.svg" width="24" height="24" alt="Slide Previous" />
        </button>
        <div bind:this={keyphrasesSliderEl} class="embla form-card-slider">
            <div class="embla__container keyprhases">
                {#each $keyphrases as card (card.id)}
                    <div
                        id={card.id}
                        class="panel form-card animate-in m-0 w-auto embla__slide {showCardStatusClass(card.status)}"
                    >
                        <button
                            class="btn-remove btn form-card-remove"
                            type="button"
                            on:click={() => removeKeyphrases(card.id)}
                        >
                            <img src="/img/close-line.svg" width="16" height="16" alt="Remove keyphrases" />
                        </button>
                        <fieldset class="form-card-fieldset">
                            <div class="form-card-row">
                                <label
                                    class="form-card-label field-label d-block mb-2 user-select-none"
                                    for={`keyword-${card.id}`}>Keyword</label
                                >
                                <input
                                    class="form-card-input field-input"
                                    type="text"
                                    id={`keyword-${card.id}`}
                                    name="keyword"
                                    placeholder="Enter keyword"
                                    disabled={card.isDisabled}
                                    bind:value={card.keyword}
                                    on:change={(e) =>
                                        debounce(validateKeyphrasesCard(e, card.id, card.keyword, card.url))}
                                />
                            </div>
                            <div class="form-card-row">
                                <label class="form-card-url field-label mb-2 user-select-none" for={`url-${card.id}`}
                                    >Reference URL</label
                                >
                                <input
                                    class="form-card-input field-input"
                                    type="text"
                                    id={`url-${card.id}`}
                                    name="url"
                                    placeholder="https://example.com"
                                    disabled={card.isDisabled}
                                    bind:value={card.url}
                                    on:change={(e) =>
                                        debounce(validateKeyphrasesCard(e, card.id, card.keyword, card.url))}
                                />
                            </div>
                        </fieldset>
                    </div>
                {/each}
                <button
                    class="panel form-card form-card-add embla__slide"
                    tabindex="0"
                    on:click={addKeypharases}
                    disabled={isLoading}
                >
                    <img
                        class="form-card-add-img user-select-none"
                        src="/img/add-line.svg"
                        width="24"
                        height="24"
                        alt="Add keyphrases"
                    />
                </button>
            </div>
        </div>
        <button
            on:click={() => keyphrasesCarousel.scrollNext()}
            class="btn embla__button embla__button--next"
            aria-label="Next"
        >
            <img src="/img/arrow-right-wide-fill.svg" width="24" height="24" alt="Slide Next" />
        </button>
    </div>
</div>

<div class="row mb-5">
    <div class="col-lg-3">
        <h4 class="form-card-title">Competitor URL</h4>
        <p class="formm-card-desc text-muted">
            Got any useful articles or web pages that you think could be helpful? Add the URLs here to share them as
            references.
        </p>
    </div>
    <div class="slider-container col-lg-9">
        <button
            on:click={competitorCarousel.scrollPrev()}
            class="btn embla__button embla__button--prev"
            aria-label="Previous"
        >
            <img src="/img/arrow-left-wide-fill.svg" width="24" height="24" alt="Slide Previous" />
        </button>
        <div bind:this={competitorUrlsSliderEl} class="embla form-card-slider">
            <div class="embla__container competitor-urls">
                {#each $competitorUrls as card (card.id)}
                    <div
                        id={card.id}
                        class="panel form-card animate-in mw-100 m-0 embla__slide {showCardStatusClass(card.status)}"
                    >
                        <button
                            class="btn-remove btn form-card-remove"
                            type="button"
                            on:click={() => removeCompetitorUrlCard(card.id)}
                        >
                            <img src="/img/close-line.svg" width="16" height="16" alt="Remove competitor URL" />
                        </button>
                        <fieldset class="form-card-fieldset">
                            <div class="form-card-row">
                                <label
                                    class="form-card-label field-label d-block mb-2"
                                    for={`competitor-url-${card.id}`}
                                >
                                    URL
                                </label>
                                <input
                                    class="form-card-input field-input"
                                    type="text"
                                    id={`competitor-url-${card.id}`}
                                    name="url"
                                    placeholder="https://example.com"
                                    disabled={card.isDisabled}
                                    on:change={(e) => debounce(validateCompetitorUrlCard(e, card.id, card.url))}
                                    bind:value={card.url}
                                />
                            </div>
                        </fieldset>
                    </div>
                {/each}
                <button class="panel form-card form-card-add embla__slide" tabindex="0" on:click={addCompetitorUrlCard}>
                    <img
                        class="form-card-add-img user-select-none"
                        src="/img/add-line.svg"
                        width="24"
                        height="24"
                        alt="Add competitor URL"
                    />
                </button>
            </div>
        </div>
        <button
            on:click={competitorCarousel.scrollNext()}
            class="btn embla__button embla__button--next"
            aria-label="Next"
        >
            <img src="/img/arrow-right-wide-fill.svg" width="24" height="24" alt="Slide Next" />
        </button>
    </div>
</div>

<button on:click={draftSubtmit} type="button" class="btn btn-submit btn-primary btn-lg btn-draft-submit">Submit</button>
</div>

<style>
    .manual-draft {
        padding: 1rem;
    }
    .slider-container {
        gap: 0;
    }
    .form-card-add {
        border: none;
    }
    .form-card-add:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
    .keyprhases .form-card-add {
        min-height: 180px;
    }
    .competitor-urls .form-card-add {
        min-height: 104px;
    }
    .embla.form-card-slider .embla__slide {
        flex: 0 0 80%;
    }
    @media screen and (min-width: 768px) {
        .embla.form-card-slider .embla__slide {
            flex: 0 0 50%;
        }
    }
    @media screen and (min-width: 992px) {
        .embla.form-card-slider .embla__slide {
            flex: 0 0 33.33%;
        }
    }
</style>
